export enum EditableThumbnailResourcePage {
  ResponsePage = 'response_page',
  ShareLibraryAll = 'share_library_all',
  ShareLibraryUploaded = 'share_library_uploaded',
  ShareLibraryRecordings = 'share_library_recordings',
  TestimonialAll = 'testimonial_library_all',
  TestimonialResponses = 'testimonial_library_responses',
  TestimonialUploads = 'testimonial_library_uploads',
}

export enum EditableThumbnailResourceType {
  TestimonialResponse = 'testimonial_response',
  Uploaded = 'uploaded',
  Recordings = 'recordings',
}
